<template>
  <v-card
    max-width="600"
    class="mx-auto pa-0"
    :loading="loading"
    :disabled="loading"
  >
    <v-card-title>
      {{ $t("create_password.title") }}
    </v-card-title>
    <v-divider color="white"></v-divider>
    <v-card-text>
      <div v-if="!complete">
        <h2 class="red--text" v-if="!valid">
          {{ $t("create_password.link_cannot_use") }}
        </h2>
        <div v-if="valid">
          <v-form ref="set_password_form" v-model="formValid">
            <v-text-field
              v-model="password_1"
              :append-icon="view_password_1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="view_password_1 ? 'text' : 'password'"
              name="input-10-1"
              label="New Password"
              :rules="password_rules"
              counter
              @click:append="view_password_1 = !view_password_1"
            ></v-text-field>
            <v-text-field
              v-model="password_2"
              :append-icon="view_password_2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="view_password_2 ? 'text' : 'password'"
              name="input-10-1"
              label="New Password again"
              :rules="password_2_rules"
              counter
              @click:append="view_password_2 = !view_password_2"
            ></v-text-field>
            <v-btn
              color="success"
              block
              class="mt-5"
              :disabled="!formValid"
              @click="set_password"
            >
              {{ $t("create_password.set_password") }}
            </v-btn>
          </v-form>
        </div>
      </div>
      <!-- <div v-if="complete">
        <h2 class="success--text">{{ $t("create_password.complete") }}</h2>
        <h3>{{ $t("create_password.can_login_now") }}</h3>
      </div> -->
    </v-card-text>
  </v-card>
</template>

<script>
import AuthProvider from "@/services/auth.provider";
import validator from "@/helper/validator";

const authService = new AuthProvider();

export default {
  name: "CreatePasswotd",
  data() {
    return {
      formValid: null,
      loading: false,
      valid: false,
      complete: false,
      view_password_1: null,
      password_1: null,
      view_password_2: null,
      password_2: null,
    };
  },
  methods: {
    async check_secure_key() {
      this.loading = true;
      if (this.secure_key !== "") {
        const check_response = await authService.checkSecureKey({
          SECURE_KEY: this.secure_key,
        });
        if (check_response.status) {
          this.valid = true;
        }
      }
      this.loading = false;
    },

    async set_password() {
      this.loading = true;
      if (this.valid && this.$refs.set_password_form.validate()) {
        const response = await authService
          .setPassword({
            SECURE_KEY: this.secure_key,
            PASSWORD: this.password_1,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.loading = false;
          });
        if (response && response.status) {
          this.complete = true;
          this.$toasted.success(this.$t("create_password.complete"), {
            duration: 0,
          });
          this.$router.push({ name: "default" });
        }
      }
      this.loading = false;
    },
  },
  computed: {
    password_rules() {
      return [validator.required, validator.min(8)];
    },
    password_2_rules() {
      return [validator.required, validator.password_match(this.password_1)];
    },
    secure_key() {
      return this.$route.query.secure_key;
    },
  },
  mounted() {
    // this.$store.dispatch("auth/logout");
    this.check_secure_key();
  },
};
</script>
